import format from 'date-fns/format';

const MAX_MONTHS = 12;

const getMonthDropdown = () => {
    const monthDropdown = [];
    const currentDate = new Date();
    currentDate.setDate(1);
    for (let i = 0; i < MAX_MONTHS; i++) {
        monthDropdown.push({
            value: format(currentDate, 'YYYYMMDD'),
            name: format(currentDate, 'MMMM YYYY'),
        });
        currentDate.setMonth(currentDate.getMonth() - 1);
    }
    return monthDropdown;
};

export {
    getMonthDropdown,
};
